export default {
    methods  : {
        formatDateISO (date) {
            return (date ? this.$moment.utc(date).toISOString() : null);
        },
        formatDateUTC (date, format) {
            if (!format) {
                format = 'DD/MM/YYYY';
            }
            return (date ? this.$moment.utc(date).format(format) : null);
        },
        formatDate (date, format) {
            if (!format) {
                format = 'DD/MM/YYYY';
            }
            // console.log('date:', date, 'format:', format, 'localDate', this.localDate(date));
            return (date ? this.$moment(this.localDate(date)).format(format) : null);
        },
        localDate (date) {
            return (date ? this.$moment.utc(date).toDate() : null);
        },
    }
}
